import VueLoader from '../../default/vue-loader'

import BottomForm from './bottom_form/form'
import H4HBottomForm from './h4h_bottom_form/form'
import PackageAvailable from './bottom_form/package_available'
import HotelIndex from './h4h_hotels/hotel_index'
import store from '../../default/store'
import init from './h4h_rooms/gmaps_initialization'


export default {
  loadBottomForm() {
    let packageDiv = document.getElementById('packageCartFormData')
    let h4hPackageDiv = document.getElementById('h4hPackageCartFormData')
    let noPurchasing = document.getElementById('packageCartFormAvailable')
    init()
    if (h4hPackageDiv) {
      VueLoader.loadVueComponent(H4HBottomForm, document.getElementById('addToCartVue'),store)
    } else if (packageDiv) {
      VueLoader.loadVueComponent(BottomForm, document.getElementById('addToCartVue'))
    } else if (noPurchasing) {
      VueLoader.loadVueComponent(PackageAvailable, document.getElementById('addToCartVue'))
    }
  },

  loadH4hForm() {
    VueLoader.loadVueComponent(HotelIndex, document.getElementById('hotelIndex'), store)
  }
}
